import type { VFC } from 'react';
import { useRouteMatch, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useUserInfo } from '@/hooks/useUser';
import { RoleName } from '@enmon/commons/lib/tools';
import { GlobalModal } from 'components/modal/GlobalModal';
import { Resellers } from './Page';
import { ResellersTab } from './enums/resellersTab';

export const ResellersRouter: VFC = () => {
  const { path } = useRouteMatch();
  const location = useLocation();
  const { role } = useUserInfo();

  return (
    <GlobalModal>
      <Switch>
        {role?.name === RoleName.Magic ? (
          <>
            <Route path={`${path}/:resellersTab`} render={() => <Resellers />} />
            <Route
              path={path}
              render={() => <Redirect to={{ pathname: `${path}/${ResellersTab.Overview}`, state: location.state }} />}
            />
          </>
        ) : (
          <Route path={path} render={() => <Redirect to={{ pathname: '/', state: location.state }} />} />
        )}
      </Switch>
    </GlobalModal>
  );
};
